import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadPeople } from "../people/loaders.ts";
import { PeoplePage } from "../people/people-page.tsx";
import { peopleTabsFor } from "../people/permissions.ts";
import { IndexPending } from "../shell/record-pending.tsx";
import { peopleSearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || peopleTabsFor(viewer).length === 0 ? (
    <NoAccessPage />
  ) : (
    <PeoplePage viewer={viewer} />
  );
};

export const Route = createFileRoute("/_app/people/")({
  validateSearch: peopleSearch,
  loader: async ({ context }) => loadPeople(context.data),
  pendingComponent: () => <IndexPending hasTabs />,
  component: Page,
});
